module.exports = __webpack_public_path__ + "static/media/hourslogo.71d21f82.svg";